var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftDoubleArrowDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#32325D",
    opacity: 0.399
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41 1.41L6 0 0 6 6 12 7.41 10.59 2.83 6z",
    transform: "translate(6 6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.41 1.41L11 0 5 6 11 12 12.41 10.59 7.83 6z",
    transform: "translate(6 6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftDoubleArrowDisabled);
export default __webpack_public_path__ + "static/media/left_double_arrow_disabled.46f7a4f01cd5322c96928063b0d88070.svg";
export { ForwardRef as ReactComponent };